import { useEffect, useState } from 'preact/hooks'
import { useTranslation } from 'react-i18next'
import DynamicFieldset from './DynamicFieldset'
import Input from './Input'
import { DrillSelect } from '@/components/forms/FuzzySelect'
import VariableUnitsInput from './VariableUnitsInput'
import { Model } from '@/types'

type Props = {
	drillingMachines: Model.DrillingMachine[] | undefined
    translation: string
}

const DrillingMachineList: FC<Props> = (p) => {
	const { t } = useTranslation(p.translation)
	const [ drillingMachines, setDrillingMachines ] = useState<Model.DrillingMachine[]>([])

    useEffect(() => {
        if (p.drillingMachines) {
            setDrillingMachines(p.drillingMachines)
        }
    }, [p.drillingMachines])

	return (
		<div class='mt-6'>
            <DynamicFieldset
                data={drillingMachines}
                label={t('select_drill')}
                make={i => (
                    <fieldset>
                        <DrillSelect
                            required
                            name={`drilling_machine[${i}][id]`}
                            label={t('select_drill')}
                            filterkey={'daily_report'}
                            defaultValue={drillingMachines[i]?.id}
                        />
                        <Input
                            className='span3'
                            required
                            integer
                            name={`drilling_machine[${i}][start_time]`}
                            label={t('start_time')}
                            defaultValue={drillingMachines[i]?.start_time}
                        />
                        <Input
                            className='span3'
                            required
                            integer
                            name={`drilling_machine[${i}][end_time]`}
                            label={t('end_time')}
                            defaultValue={drillingMachines[i]?.end_time}
                        />
                        <VariableUnitsInput
                            choices='litersOrGallons'
                            name={`drilling_machine[${i}][fuel_liters]`}
                            label={t('fuel')}
                            defaultValue={drillingMachines[i]?.fuel_liters}
                        />
                    </fieldset>
                )}
            ></DynamicFieldset>
        </div>
        
		
	)

}
export default DrillingMachineList
